import * as React from "react";
import logo from "../images/logo_dell.png";
import help from "../images/help.png";
import { Trans,useTranslation } from "react-i18next";
import { useParams, useNavigate, Link  } from "react-router-dom";
import Footer from "../components/Footer";
import refresh from "../images/refresh.png";
import RegistrationService from "../services/RegistrationService";
import User from "../types/User";
import Users from "../types/Users";
import { ChangeEvent, useEffect, useState } from "react";
import i18next from "i18next";
import CaptchaService from "../services/CaptchaService";
import CountryService from "../services/CountryService";
import StateService from "../services/StateService";
import TimeZoneService from "../services/TimeZoneService";
import { Tooltip as ReactTooltip } from "react-tooltip";
import WMSVersionService from "../services/WMSVersionService";

interface obj {
    name: string,
    value: string
    children?: obj[]
}

const Header = () => {
    const { t } = useTranslation("common");
    const dell_logo = t("dell");
    const lang_opts = [{ value: "en", name: "English (US)" },
    { value: "fr", name: "Français" },
    { value: "de", name: "Deutsch" },
    { value: "it", name: "Italiano" },
    { value: "es", name: "Español" },
    { value: "zhcn", name: "中文" },
    { value: "ja", name: "日本語" }];
    const [defVal, setDefVal] = useState(lang_opts[0].value);
    const { id } = useParams();
    const navigate = useNavigate();
    useEffect(()=>{
        if(localStorage && localStorage.getItem("lang_val")){
            setDefVal(localStorage.getItem("lang_val")||lang_opts[0].value);
        } else{
            setDefVal(lang_opts[0].value);
        }
        i18next.changeLanguage(defVal);
        if(!(id == "tc" || id == "new" || id == "renew")) {
            navigate("/notfound", { replace: true });
        }
    },[defVal, id, navigate])
    
    const changeLang = (str:string) =>{
        localStorage.setItem("lang_val",str);
        setDefVal(str);
        i18next.changeLanguage(str);
    }
    return (
        <header className="dell-bg">
        <div className="container " id="container-header">
            <div className="d-flex align-items-center p-1">
                <div>
                    <a href="/" className="d-flex text-dark text-decoration-none align-items-center">
                        <img className="dell-logo" src={logo} alt={dell_logo} />
                        <span className="fs-6 text-blue px-md-3">{t("wyse_label")}</span>
                    </a>
            </div>
                <div className="dropdown ms-auto me-3">
                </div>
                <div>
                <select className="form-select" value={defVal} onChange={(e: any) => changeLang(e.target.value) }>
                    {lang_opts.map((lang: obj) => (<option value={lang.value} key={lang.value}>{lang.name}</option>))}
                </select>
            </div>
            </div>
        </div>
    </header>
    )
}

const Content = () => {
    const { t } = useTranslation("common");
    const { id } = useParams();
    const navigate = useNavigate();
    const [dCaptcha, setDCaptcha] = useState("");
    const [dCaptchastd, setDCaptchastd] = useState("");
    const [dMachineIdentifier,setDMachineIdentifier]=useState("");
    const [captchaText, setCaptchaText] = useState("");
    let param:any = "tc";
    if (id !== undefined) {
        param = id;
    } 

    const devices: any = { tc: t("start")+" "+t("tc")+" "+ t("trial"), iot: t("try")+" "+t("iot")+" "+t("90_days") };
    const hear_options = [{ value: "", name: "--" },
    { value: "ExistingCustomer", name: t("existing_cust") },
    { value: "Friend", name: t("referred") },
    { value: "Sales Person", name: t("from_sales") },
    { value: "Online search", name: t("online_search") },
    { value: "analyst", name:  t("via_analyst")},
    { value: "Media", name: t("via_media") },
    { value: "Other", name: t("other") }];

    const initialRegistrationState:User = {
        firstName: "",
        lastName: "",
        phone: "",
        tenantName:"",
        country:"",
        city:"",
        zipCode:"",
        email: "",
        password:"",
        timeZone:"",
        wmsVersion:""
      };  
      const initialRegistrationStates:Users = {
        firstName: "",
        lastName: "",
        phone: "",
        customerName:"",
        country:"",
        city:"",
        zipCode:"",
        email: "",
        timeZone:"",
        wmsVersion:""
      };
    const [Users, setUSers] = useState(initialRegistrationStates);
    const [user, setUser] = useState(initialRegistrationState);  
    const [countries, setCountries ] = useState();
    const [wmsVersions, setWmsVersions] = useState();
    const [wmsVersion, setWmsVersion] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [warningKey, setWarningKey] = useState<"ABOVE_WMS_5_X" | "ABOVE_WMS_5_4" | "BELOW_WMS_4_X" | null>(null);
    const [country, setCountry] = useState("");
    const [states, setStates ] = useState();
    const [state, setState] = useState("");
    const [timeZone, SetTimeZone] = useState("");
    const [timeZones, setTimeZones] = useState();
    const [ acknowledge, setAcknowledge ] = useState(false);
    const [ acknowledgestInstall, setAcknowledgestInstall ] = useState(false);
    const [ tandc, setTandc ] = useState(false);
    const [ tandcstd, setTandcstd ] = useState(false);
    const [ cpswrd, setCpswrd ] = useState("");
    const [knowfrom, setKnowFrom] = useState(hear_options[0].value);
    const [ loader, setLoader ] = useState(false);
    const [ loaderstd, setLoaderstd ] = useState(false);
    const [showVersionConfirm, setShowVersionConfirm] = useState(false);
    const [isRegistrationTab, setIsRegistrationTab] = useState(false);

    useEffect(() => {
        CountryService.getCountries().then((response:any)=>{
            // console.log(response.data);
            if(response.status === 200){
                setCountries(response.data);
                setCountry(Object.keys(response.data)[0]);
            }else{
                alert("&#9888; " + response.message);
            }
        }).catch((e:any)=>{
            alert("&#9888; " + e.message + " " + t("in_getting") + " " + t("countries"));
        });
        TimeZoneService.getTimeZones().then((response:any)=>{
            // console.log(response.data);
            if(response.status === 200){
                setTimeZones(response.data);
            }else{
                alert("&#9888; " + response.message);
            }
        }).catch((e:any)=>{
            alert("&#9888; " + e.message + " " + t("in_getting") + " " + t("t_zones"));
        });
       
        WMSVersionService.getWMSVersions().then((response:any)=>{
            // console.log(response.data);
            if(response.status === 200){
                setWmsVersions(response.data);
            }else{
                alert("&#9888; " + response.message);
            }
        }).catch((e:any)=>{
            alert("&#9888; " + e.message + " " + t("in_getting") + " WMS versions");
        });
       
            loadCaptcha();
                 
         loadCaptchastd();
         

        /* work around to scroll to top*/
        setTimeout(() => {
            document.getElementById("firstName")?.focus();
        }, 10);
    }, []);
    useEffect(()=>{
        if(country === "US"){
            StateService.getUSStates().then((response:any)=>{
                // console.log(response.data);
                if(response.status === 200){ 
                    setStates(response.data); 
                    setState(Object.keys(response.data)[0]);
                }else{
                    alert("&#9888; " + response.message);
                }           
            }).catch((e:any)=>{
                alert("&#9888; " + e.message + " " + t("in_getting") + " " + t("us_states"));
            });
        }
        if(country === "CA"){
            StateService.getCanadaStates().then((response:any)=>{
                // console.log(response.data);
                if(response.status === 200){ 
                    setStates(response.data);
                    setState(Object.keys(response.data)[0]);
                }else{
                    alert("&#9888; " + response.message);
                }           
            }).catch((e:any)=>{
                alert("&#9888; " + e.message + " " + t("in_getting") + " " + t("ca_states"));
            });
        }
    },[country]);

    useEffect(()=>{
        setUser({...user, country, timeZone, wmsVersion});
        setUSers({...Users, country, timeZone, wmsVersion})
    },[country, timeZone, wmsVersion]);

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { id, value } = event.target;
        setUser({ ...user, [id]: value });
        if(id !== "password") {
            setUSers({...Users,[id]: value});
        }
        };
    const handleChange = (value: string) => {
        setWmsVersion(value);

        if (value && value == "ABOVE_WMS_5_X" || value == "BELOW_WMS_4_X") {
          setWarningKey("ABOVE_WMS_5_X");
          setShowModal(true);
        } else if (value && value == "ABOVE_WMS_5_4") {
          setWarningKey("ABOVE_WMS_5_4");
          setShowModal(true);
        } else {
          setWarningKey(null);
        }
      };

    const validateFormTab2 = ()=>{
        let valid = false;
        // console.log(user);
        let key: keyof typeof Users;
        for (key in Users) {
            if (Users.hasOwnProperty(key)) {
                let str = "";
                if(key === "country" || key === "timeZone"){
                    str = t("select");
                }else{
                    str = t("enter");
                }
                if(Users[key] ===""){
                    alert("&#9888; " + t("please") + " " + str + " " + t(key));
                    valid = false;
                    document.getElementById(key)?.focus();
                    break;
                } 
                else if(Users["customerName"] ===""){
                    alert("&#9888; " + t("please") + " " + str + " " + t("Company name"));
                    valid = false;
                    document.getElementById(key)?.focus();
                    break;  
                }
                else if(Users[key].includes("<")){
                    alert("&#9888; " + t("please") + " " + str + " " + t("valid") + " " + t(key));
                    valid = false;
                    document.getElementById(key)?.focus();
                    break;
                } else if(key === "firstName" || key === "lastName"){
                    let pattern = new RegExp(/^[A-Za-z',\s\d-]{1,255}$/);
                    if(!pattern.test(Users[key])){
                        alert("&#9888; " + t("please") + " " + str + " " + t("valid") + " " +  t(key));
                        valid = false;
                        document.getElementById(key)?.focus();
                        break;
                    }
                } else if(key === "phone" && Users[key] !== ""){
                    let pattern = new RegExp(/^[0-9\(\)\/\+\-\.\s]{1,63}$/);
                    if(!pattern.test(Users[key])){
                        alert("&#9888; " + t("please") + " " + str + " " + t("valid") + " " + t(key));
                        valid = false;
                        document.getElementById(key)?.focus();
                        break;
                    }
                }else if(key === "zipCode" && Users[key] !== ""){
                    let pattern = new RegExp(/^.{1,23}$/);
                    if(!pattern.test(Users[key])){
                        alert("&#9888; " + t("please") + " " + str + " " + t("valid") + " " + t(key));
                        valid = false;
                        document.getElementById(key)?.focus();
                        break;
                    }
                }else if(key === "email" && Users[key] !== ""){
                    let pattern = new RegExp(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$/g);
                    if(!pattern.test(Users[key])){
                        alert("&#9888; " + t("please") + " " + str + " " + t("valid") + " " + t(key));
                        valid = false;
                        document.getElementById(key)?.focus();
                        break;
                    }
                }
                
                else{
                    valid = true;
                }
            }
        }
        return valid;
    }
    const validateForm = ()=>{
        let valid = false;
        // console.log(user);
        let key: keyof typeof user;
        for (key in user) {
            if (user.hasOwnProperty(key)) {
                let str = "";
                if(key === "country" || key === "timeZone"){
                    str = t("select");
                }else{
                    str = t("enter");
                }
                if(user[key] ==="" && key !== "wmsVersion"){
                    alert("&#9888; " + t("please") + " " + str + " " + t(key));
                    valid = false;
                    document.getElementById(key)?.focus();
                    break;
                } else if(user[key].includes("<")){
                    alert("&#9888; " + t("please") + " " + str + " " + t("valid") + " " + t(key));
                    valid = false;
                    document.getElementById(key)?.focus();
                    break;
                } else if(key === "firstName" || key === "lastName"){
                    let pattern = new RegExp(/^[A-Za-z',\s\d-]{1,255}$/);
                    if(!pattern.test(user[key])){
                        alert("&#9888; " + t("please") + " " + str + " " + t("valid") + " " +  t(key));
                        valid = false;
                        document.getElementById(key)?.focus();
                        break;
                    }
                } else if(key === "phone" && user[key] !== ""){
                    let pattern = new RegExp(/^[0-9\(\)\/\+\-\.\s]{1,63}$/);
                    if(!pattern.test(user[key])){
                        alert("&#9888; " + t("please") + " " + str + " " + t("valid") + " " + t(key));
                        valid = false;
                        document.getElementById(key)?.focus();
                        break;
                    }
                }else if(key === "zipCode" && user[key] !== ""){
                    let pattern = new RegExp(/^.{1,23}$/);
                    if(!pattern.test(user[key])){
                        alert("&#9888; " + t("please") + " " + str + " " + t("valid") + " " + t(key));
                        valid = false;
                        document.getElementById(key)?.focus();
                        break;
                    }
                }else if(key === "email" && user[key] !== ""){
                    let pattern = new RegExp(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$/g);
                    if(!pattern.test(user[key])){
                        alert("&#9888; " + t("please") + " " + str + " " + t("valid") + " " + t(key));
                        valid = false;
                        document.getElementById(key)?.focus();
                        break;
                    }
                }else if(key === "password" && user[key] !== ""){
                    let pattern = new RegExp(/^(?=.*[A-Z][a-z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d][A-Za-z\d!@#$%^&*()_+]{8,127}$/gm)
                    if(user[key] !== cpswrd){
                        if(cpswrd === ""){
                            alert("&#9888; " + t("please") + " " + str + " " + t("c_pass"));
                            valid = false;
                            document.getElementById("cpswrd")?.focus();
                            break;
                        }else{
                            alert("&#9888; " + t("not_match"));
                            setCpswrd("");
                            valid = false;
                            document.getElementById("cpswrd")?.focus();
                            break;
                        }
                    }
                    if(!pattern.test(user[key])||user[key].toLowerCase().includes(user.firstName.toLowerCase())||user[key].toLowerCase().includes(user.lastName.toLowerCase())){
                        alert("&#9888; " + t("pass_check"));
                        valid = false;
                        //resetFields();
                        document.getElementById(key)?.focus();
                        break;
                    }
                } else if(key === "wmsVersion" && user[key] === ""){
                    console.log(user)
                    alert(t("selectWMSVersion"));
                    valid = false;
                    document.getElementById(key)?.focus();
                    break;
                } else {
                    valid = true;
                }
            }
        }
        return valid;
    }
    const loadCaptcha = () =>{
        CaptchaService.getCaptcha().then((response:any)=>{
            // console.log(response.data);
            if(response.status === 200){
                setCaptchaText(response.data);
            }else{
                alert("&#9888; " + response.message); 
            }
        }).catch((e:any)=>{
            alert("&#9888; " + e.message + " " + t("in_getting") + " " + t("captcha"));
        });
    }
    const loadCaptchastd = () =>{
        CaptchaService.getCaptcha().then((response:any)=>{
            // console.log(response.data);
            if(response.status === 200){
                setCaptchaText(response.data);
            }else{
                alert("&#9888; " + response.message); 
            }
        }).catch((e:any)=>{
            alert("&#9888; " + e.message + " " + t("in_getting") + " " + t("captcha"));
        });
    }
    const resetFields = () =>{
        setUser({...user, password:""});
        let pObj = document.getElementById("password") as HTMLInputElement;
        pObj.value= "";
        setCpswrd("");
        setDCaptcha("");
        // setDMachineIdentifier("");
        loadCaptcha();
        setAcknowledge(false);
        setTandc(false);
    }
    const resetFieldsform2 = () =>{
    //    setUSers({...Users, email: ""});
    //    let pObj = document.getElementById("email") as HTMLInputElement;
    //     pObj.value= "";
        setDCaptchastd("");
       // setDMachineIdentifier("");
        loadCaptchastd();
        setAcknowledgestInstall(false);
        setTandcstd(false);
    }

    const [isTabVisible, setIsTabVisible] = useState(true);
    
    const [activeTab, setActiveTab] = useState(()=> {
        if(param === "tc") {
            setIsTabVisible(true);
            return "tab1";
        } else if(param === "new") {
            setIsTabVisible(true);
            return "tab2";
        } else if(param === "renew") {
            setIsTabVisible(true);
            return "tab3";
        }
    });

    
    const handleTabClick = (tab: string) => {
        navigate(tab);
        if(tab === '/trial/tc') {
            setActiveTab('tab1');
        } else if(tab === '/stdInstall/new') {
            setActiveTab('tab2');
        } else if(tab === '/stdInstall/renew') {
            setActiveTab('tab3');
        }
    }; 
    
    const registerUser = () => {
        if(validateForm()){
            if(knowfrom){
                setLoader(true);
                setAcknowledge(false); //to disable submit
                let data:any = {};
                let clients:any = {tc:"WMS",iot:"EDM", new:"WMS", renew:"WMS"};
                data.client = clients[param];
                data.tenantDetails = {...user};
                if(country === "CA" || country === "US"){
                    data.tenantDetails.state = state;
                    if(data.tenantDetails.state === ""){
                        alert("&#9888; "+ t("please") + " " + t("select") + " " + t("state_pr"));
                        return true;
                    }
                }
                data.captchaText = dCaptcha;
                RegistrationService.create(data).then((response:any)=>{
                    //console.log(response.data);
                    //alert("&#9989; "+response.data.message);
                    localStorage.setItem("client",clients[param]);
                    localStorage.setItem("loginUrl",response.data.loginUrl);
                    setLoader(false);
                    setAcknowledge(true); //to enable submit
                    alert("registration Successful");
            
                    navigate("../confirmation/success");
                }).catch((e:any)=>{
                    if(e.response.status === 400){
                        alert("&#9888; "+e.response.data.message);
                        setLoader(false);
                        setAcknowledge(true); //to enable submit
                        resetFields();
                    } else {
                       navigate("../confirmation/error");
                    }
                });
            }else{
                alert("&#9888; "+ t("please") + " " + t("select") + " " + t("hw_hr"));
            }
        }       
    }
    
    const registerWmsStandard = () => {
         if(validateFormTab2()){
            if(knowfrom){
                setLoaderstd(true);
                setAcknowledgestInstall(false); //to disable submit
                let data:any = {};
                let clients:any = {tc:"WMS", new:"WMS", renew:"WMS"};
                data.client = clients[param];
                data.customerDetails = {...Users};
                
                if(country === "CA" || country === "US"){
                    data.customerDetails.state = state;
                    if(data.customerDetails.state === ""){
                        alert("&#9888; "+ t("please") + " " + t("select") + " " + t("state_pr"));
                        return true;
                    }
                }
                data.machineIdentifier = dMachineIdentifier;
                data.captchaText = dCaptchastd;
                data.wmsVersion = wmsVersion;
                  // console.log(data);
                   RegistrationService.regStandard(data).then((response:any)=>{
                   // console.log(response.data);
                  //  alert("&#9989; "+response.data.message);
                    localStorage.setItem("client",clients[param]);
                    localStorage.setItem("loginUrl",response.data.loginUrl);
                    setLoaderstd(false);
                    setAcknowledgestInstall(true);
                   // alert("registration Successful");
                    navigate("../Confirmationmsg/success");
                  }).catch((e:any)=>{
                   
                    if(e.response.status === 400){
                        alert("&#9888; "+e.response.data.message);
                       // alert("The Standard WMS Key is already generated for the On-Prem Identifier. Please check the mail or contact Dell Support for the Standard WMS Key.");
                        setLoaderstd(false);
                        setAcknowledgestInstall(true); //to enable submit
                        resetFieldsform2();
                    } 
                  
                    else {
                      navigate("../Confirmationmsg/error");
                     
                    }
                });
            }
            else{
                alert("&#9888; "+ t("please") + " " + t("select") + " " + t("hw_hr"));
            }
        }       
    }

    const validateFormTab3 = ()=>{
        let valid = false;
        let key: keyof typeof Users;
        
        for (key in Users) {
            if (Users.hasOwnProperty(key)) {
                let str = "";
                if(key === "country"){
                    str = t("select");
                }else{
                    str = t("enter");
                }

                if(Users[key] === "" && (key === "country" || key === "wmsVersion")){
                    alert("&#9888; " + t("please") + " " + str + " " + t(key));
                    valid = false;
                    document.getElementById(key)?.focus();
                    break;
                } else if(Users[key].includes("<")){
                    alert("&#9888; " + t("please") + " " + str + " " + t("valid") + " " + t(key));
                    valid = false;
                    document.getElementById(key)?.focus();
                    break;
                } else if(key === "email"){
                        if( Users[key] !== ""){
                            let pattern = new RegExp(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$/g);
                            if(!pattern.test(Users[key])){
                                alert("&#9888; " + t("please") + " " + str + " " + t("valid") + " " + t(key));
                                valid = false;
                                document.getElementById(key)?.focus();
                                break;
                            }
                        }
                } else {
                    valid = true;
                }
            }
        }
        return valid;
    }

    const resetFieldsForm3 = () =>{
        setDCaptchastd("");
        loadCaptchastd();
        setAcknowledgestInstall(false);
        setTandcstd(false);
        setDMachineIdentifier("");
    }

    const registerWmsRenewal = () => {
        if(validateFormTab3()){
            setLoaderstd(true);
            setAcknowledgestInstall(false); //to disable submit
            let data:any = {};

            data.machineIdentifier = dMachineIdentifier;
            data.captchaText = dCaptchastd;
            data.region = Users.country;
            data.emailId = Users.email;
            data.emailUpdate = true;
            data.wmsVersion = wmsVersion;

            let clients:any = {tc:"WMS", new:"WMS", renew:"WMS"};
            data.client = clients[param];

            RegistrationService.standardRenewal(data).then((response:any)=>{
                localStorage.setItem("loginUrl",response.data.loginUrl);
                setLoaderstd(false);
                setAcknowledgestInstall(true);
                navigate("../Confirmationmsg/successRenewal");
                resetFieldsForm3();
                }).catch((e:any)=>{

                if(e.response.status === 400){
                    alert("&#9888; "+e.response.data.message);
                    setLoaderstd(false);
                    setAcknowledgestInstall(true); //to enable submit
                    resetFieldsForm3();
                }

                else {
                  navigate("../Confirmationmsg/errorRenewal");

                }
            });
        }
   }


    return (
        <div className="pt-4">
            {(<div className={isTabVisible ? "form-tab-button": "form-tab-button-hidden"} >
                <div id="formTab">
                    <button id="Wmt" onClick={() => handleTabClick('/trial/tc')}
                        className={activeTab === 'tab1' ? 'active' && 'btn text-white btn-secondary' : ''}>{t("wmt")}</button>
                    <button id="Wms" onClick={() => handleTabClick('/stdInstall/new')}
                        className={activeTab === 'tab2' ? 'active' && 'btn text-white btn-secondary' : ''}>{t("wms")}</button>
                    <button id="Wmr" onClick={() => handleTabClick('/stdInstall/renew')}
                        className={activeTab === 'tab3' ? 'active' && 'btn text-white btn-secondary' : ''}>{t("wmr")}</button>
                </div></div>)}

            {activeTab === 'tab3' && (<div id="wmr-form" >
                        <h2 className="text-center hd-txt">{t("renew_wms_std")}</h2>
                        <div className="row offset-md-2 col-md-8 mt-25">
                            <form className="row g-3" autoComplete="off">
                                <div className="col-md-6">
                                    <label htmlFor="email" className="form-label">{t("form_mail")}</label>
                                    <img src={help} alt="tt_info" data-tooltip-id="email-renwal-tooltip"/>
                                    <input type="email" className="form-control" id="email" autoComplete="off" onChange={handleInputChange}/>
                                    <ReactTooltip id="email-renwal-tooltip" place="right">
                                    {t("renewal_email_tooltip")}
                                    </ReactTooltip>
                                    <div>{t("form3_mail_desc")}</div>
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="country" className="form-label">{t("form_cntry")} <span className="text-danger">*</span></label>
                                    <select id="country" className="form-select" onChange={(e: any) => {setCountry(e.target.value)}}>
                                        {countries && Object.keys(countries).map((obj:string)=>(
                                        <option key={obj+" country"} value={obj}>{countries[obj]}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">{t("renewal_identifier")} <span className="text-danger">*</span></label>
                                    <img src={help} alt="tt_info" data-tooltip-id="renewal-identifier-tt"/>
                                    <input type="text"  value={dMachineIdentifier} className="form-control" id="machineIdentifier" autoComplete="off"  onChange={(e: React.FormEvent<HTMLInputElement>) => setDMachineIdentifier(e.currentTarget.value)}/>
                                    <ReactTooltip id="renewal-identifier-tt" place="right">
                                    {t("renewl_identifier_tooltip")}
                                    </ReactTooltip>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">{t("wms-version")}<span className="text-danger">*</span></label>
                                    <span className="tooltip-text ms-1" id= "renewal-version-text" data-tooltip-id="renewal-version-tt">
                                      {t("wms-version-tooltip")}
                                    </span>
                                    <ReactTooltip id="renewal-version-tt" style={{ whiteSpace: "pre-line" }} place="right">
                                        {t("renewal_version_tooltip")}
                                    </ReactTooltip>
                                    <select id="wmsVersions" className="form-select" onChange={(e: any) => {handleChange(e.target.value)}}>
                                        <option key="" value="">{t("select")}</option>
                                        {wmsVersions && Object.keys(wmsVersions).map((key:any)=>(
                                        <option key={key} value={wmsVersions[key]}>{t(wmsVersions[key])}</option>
                                        ))}
                                    </select>
                                </div>

                                {showModal && (
                                      <div className="custom-modal-overlay">
                                        <div className="custom-modal-version">
                                          <h5> {t(`modalTitle.${warningKey}`)}</h5>
                                           <p className="custom-modal-content" style={{ whiteSpace: "pre-line" }}>
                                             <Trans
                                               ns="common"
                                               i18nKey={`warnings.${warningKey}`}
                                               values={{
                                                 version: t(wmsVersion),
                                                 latestVersion: "WMS Pro version"
                                               }}
                                               components={[
                                                   <strong />,
                                                 <Link to="/thinclient" className="text-blue" />
                                               ]}
                                             />
                                           </p>

                                  <div className="modal-actions">

                                       <button className="btn-cfm" onClick={() => setShowModal(false)} >
                                             {t("acknowledgeButton")}
                                       </button>
                                  </div>
                                        </div>
                                      </div>
                                )}

                                <div className="col-md-12 mt-25">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="acknowledge2" autoComplete="off" checked={acknowledgestInstall} onChange={()=>{setAcknowledgestInstall(!acknowledgestInstall)}}/>
                                        <label className="form-check-label" htmlFor="acknowledgestInstall">
                                            {t("form_ack")}
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-25">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="tandc2" autoComplete="off" checked={tandcstd} onChange={()=>{setTandcstd(!tandcstd)}}/>
                                        <label className="form-check-label" htmlFor="tandcstd">
                                            {t("form_tac1")} <a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/learn/us/en/uscorp1/terms-conditions/art-software-license-agreements">{t("form_tac2")}</a> {t("form_tac3")}
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-12 row mt-25">
                                    <div className="col-md-4">
                                        <div className="captcha text-center br-5 mr-5 text-light prevent-select">{captchaText}</div>
                                    </div>
                                    <div className="col-md-1">
                                        <a className="mt-5-custom" title="Click to change captcha" onClick={() => loadCaptchastd()}><img src={refresh} alt="" /></a>
                                    </div>
                                    <div className="col-md-3">
                                        <label htmlFor="captchaText" className="form-label mt-15 text-center">{t("form_captcha")} <span className="text-danger">*</span> &rarr;</label>
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" value={dCaptchastd} autoComplete="off" onChange={(e: React.FormEvent<HTMLInputElement>) => setDCaptchastd(e.currentTarget.value)} className="form-control mt-10" id="captchaTextstd" />

                                    </div>
                                </div>
                                <div className="col-12 text-center">
                                    <a
                                      className={`btn text-white btn-secondary btn-lg ${
                                        acknowledgestInstall && tandcstd ? "" : "disabled"
                                      }`}
                                      onClick={() => {
                                        if (!(acknowledgestInstall && tandcstd) || loaderstd) return;
                                        if (!validateFormTab3()) return;
                                        setShowVersionConfirm(true);
                                      }}
                                    >
                                      {t("Generate Renew Key")}
                                      {loaderstd ? <span className="loaderstd"></span> : ""}
                                    </a>
                                </div>
                            </form>
                        </div>

                        </div>
                        )}

            {showVersionConfirm && (
              <div className="custom-modal-overlay">
                <div className="custom-modal">
                  <h5>{t("wms_version_modal_title")}</h5>
                  <p className = "custom-version-content" style={{ whiteSpace: "pre-line" }}>
                     <Trans
                        ns="common"
                        i18nKey={isRegistrationTab ? 'wms_version_modal_desc_registration' : 'wms_version_modal_desc'}
                        values={{
                          version: t(wmsVersion)
                        }}
                        components={[
                            <strong />
                        ]}
                      />
                  </p>



                  <div className="modal-actions">
                    <button
                      className="btn-cnc"
                      onClick={() => {
                          setShowVersionConfirm(false);
                          setIsRegistrationTab(false);
                          }
                      }
                    >
                      {t("back_btn")}
                    </button>

                    <button
                      className="btn-cfm"
                      onClick={() => {
                        setShowVersionConfirm(false);
                        if(isRegistrationTab) {
                            setIsRegistrationTab(false);
                            registerWmsStandard();

                        }else {
                            registerWmsRenewal();
                        }
                      }}
                    >
                      {t("confirm_btn")}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'tab2' && (<div id="wms-form" >
            <h2 className="text-center hd-txt">{t("register_wms_st_install")}</h2>
            <div className="row offset-md-2 col-md-8 mt-25">
                <form className="row g-3" autoComplete="off">
                    <div className="col-md-6">
                        <label htmlFor="firstName" className="form-label">{t("form_fn")} <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" id="firstName" autoComplete="off" onChange={handleInputChange} required/>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="lastName" className="form-label">{t("form_ln")} <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" id="lastName" autoComplete="off" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="phone" className="form-label">{t("form_ph")} <span className="text-danger">*</span></label>
                        <img src={help} alt="tt_info" data-tooltip-id="tt-phone"/>
                        <input type="text" className="form-control" id="phone" autoComplete="off" onChange={handleInputChange} />
                        <ReactTooltip id="tt-phone" place="right">
                        Phone numbers can be up to 64 characters in length and should consist only of digits (0-9). Special characters such as '+', ',', '.', '(', ')', and '-' are allowed, but the '+' character can only appear at the beginning of the phone number.
                        </ReactTooltip>
                            </div>
                     <div className="col-md-6">
                        <label htmlFor="customerName" className="form-label">{t("form_cmpny")} <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" id="customerName" autoComplete="off" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="country" className="form-label">{t("form_cntry")} <span className="text-danger">*</span></label>
                        <select id="country" className="form-select" onChange={(e: any) => {setCountry(e.target.value)}}>
                            {countries && Object.keys(countries).map((obj:string)=>(
                               <option key={obj+" country"} value={obj}>{countries[obj]}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-6">
                            <label htmlFor="state" className="form-label">{country === "US" ? <span>Select State<span className="text-danger">*</span></span> : country === "CA" ? <span>Select State<span className="text-danger">*</span></span> :""}</label>
                            {country === "US" ? <select id="state" className="form-select" onChange={(e: any) => {setState(e.target.value)}}>
                            {states && Object.keys(states).map((obj:string)=>(
                                <option key={obj+" state"} value={obj}>{states[obj]}</option>
                             ))}
                             </select>
                             : country === "CA" ? <select id="state" className="form-select" onChange={(e: any) => {setState(e.target.value)}}>
                             {states && Object.keys(states).map((obj:string)=>(
                                 <option key={obj+" state"} value={obj}>{states[obj]}</option>
                              ))}
                              </select> :""}
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="city" className="form-label">{t("form_ct")} <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" id="city" autoComplete="off" onChange={handleInputChange}/>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="zipCode" className="form-label">{t("form_pcode")} <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" id="zipCode" autoComplete="off" onChange={handleInputChange}/>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="email" className="form-label">{t("form_mail")} <span className="text-danger">*</span></label>
                        <input type="email" className="form-control" id="email" autoComplete="off" onChange={handleInputChange}/>
                        <div>{t("form_mail_desc")}</div>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="timeZone" className="form-label">{t("form_ttz")} <span className="text-danger">*</span></label>
                        <select id="timeZone" className="form-select" onChange={(e: any) => {SetTimeZone(e.target.value)}}>
                            {timeZones && Object.keys(timeZones).map((obj:any)=>(
                               <option key={obj+" time_zone"} value={obj}>{timeZones[obj]}</option>
                            ))}
                        </select>
                        <div>
                            {t("form_ttz_desc")}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="knowfrom" className="form-label">{t("form_how_hear")} {t(`${id}`)} <span className="text-danger">*</span></label>
                        <select id="knowfrom" className="form-select" onChange={(e:any)=>{setKnowFrom(e.target.value)}}>
                        {hear_options.map((opt: obj, i: number) => (<option value={opt.value} key={opt.value + i}>{opt.name}</option>))}
                        </select>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">{t("On_Prem_MI")} <span className="text-danger">*</span></label>
                        <img src={help} alt="tt_info" data-tooltip-id="tt-machineIdentifier"/>
                        <input type="text"  value={dMachineIdentifier} className="form-control" id="machineIdentifier" autoComplete="off"  onChange={(e: React.FormEvent<HTMLInputElement>) => setDMachineIdentifier(e.currentTarget.value)}/>
                        <ReactTooltip id="tt-machineIdentifier" place="right">
                        Copy the On-Prem Machine Identifier from WMS OOBE. The Hostname of the On-Prem Machine Identifier is optional.
                        </ReactTooltip>
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">{t("wms-version")}<span className="text-danger">*</span></label>
                        <span className="tooltip-text ms-1" id= "renewal-version-text" data-tooltip-id="renewal-version-tt">
                            {t("wms-version-tooltip")}
                        </span>
                        <ReactTooltip id="renewal-version-tt" style={{ whiteSpace: "pre-line" }} place="right">
                            {t("renewal_version_tooltip")}
                        </ReactTooltip>
                        <select id="wmsVersions" className="form-select" onChange={(e: any) => {handleChange(e.target.value)}}>
                            <option key="" value="">{t("select")}</option>
                            {wmsVersions && Object.keys(wmsVersions).map((key:any)=>(
                               <option key={key} value={wmsVersions[key]}>{t(wmsVersions[key])}</option>
                            ))}
                        </select>
                    </div>

                    {showModal && (
                          <div className="custom-modal-overlay">
                            <div className="custom-modal-version">
                              <h5> {t(`modalTitle.${warningKey}`)}</h5>
                               <p className="custom-modal-content" style={{ whiteSpace: "pre-line" }}>
                                <Trans
                                  ns="common"
                                  i18nKey={`warnings.${warningKey}`}
                                  values={{
                                    version: t(wmsVersion),
                                    latestVersion: "WMS Pro version"
                                  }}
                                  components={[
                                      <strong />,
                                    <Link to="/thinclient" className="text-blue" />
                                  ]}
                                />
                              </p>

                      <div className="modal-actions">

                           <button className="btn-cfm" onClick={() => setShowModal(false)} >
                                 {t("acknowledgeButton")}
                           </button>
                      </div>
                            </div>
                          </div>
                    )}

                    <div className="col-md-12 mt-25">
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="acknowledge2" checked={acknowledgestInstall} autoComplete="off" onChange={()=>{setAcknowledgestInstall(!acknowledgestInstall)}}/>
                            <label className="form-check-label" htmlFor="acknowledgestInstall">
                                {t("form_ack")}
                            </label>
                        </div>
                    </div>
                    <div className="col-md-12 mt-25">
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="tandc2" checked={tandcstd} autoComplete="off" onChange={()=>{setTandcstd(!tandcstd)}}/>
                            <label className="form-check-label" htmlFor="tandcstd">
                                {t("form_tac1")} <a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/learn/us/en/uscorp1/terms-conditions/art-software-license-agreements">{t("form_tac2")}</a> {t("form_tac3")}
                            </label>
                        </div>
                    </div>
                    <div className="col-md-12 row mt-25">
                        <div className="col-md-4">
                            <div className="captcha text-center br-5 mr-5 text-light prevent-select">{captchaText}</div>
                        </div>
                        <div className="col-md-1">
                            <a className="mt-5-custom" title="Click to change captcha" onClick={() => loadCaptchastd()}><img src={refresh} alt="" /></a>
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="captchaText" className="form-label mt-15 text-center">{t("form_captcha")} <span className="text-danger">*</span> &rarr;</label>
                        </div>
                        <div className="col-md-4">
                            <input type="text" value={dCaptchastd} autoComplete="off" onChange={(e: React.FormEvent<HTMLInputElement>) => setDCaptchastd(e.currentTarget.value)} className="form-control mt-10" id="captchaTextstd" />

                        </div>
                    </div>
                    <div className="col-12 text-center">
                        <a className={`btn text-white btn-secondary btn-lg ${acknowledgestInstall && tandcstd ? "":"disabled"}`} onClick={() => {if (!validateFormTab2()) return;setShowVersionConfirm(true); setIsRegistrationTab(true)}}>{t("Register")} {loaderstd ? <span className="loaderstd"></span> : "" }</a>
                    </div>
                </form>
            </div>

            </div>
            )}

           {activeTab === 'tab1' && (  <div id="wmt-form">
            <h2 className="text-center hd-txt">{devices[param]}</h2>
            <div className="row offset-md-2 col-md-8 mt-25">
                <form className="row g-3" autoComplete="off">
                    <div className="col-md-6">
                        <label htmlFor="firstName" className="form-label">{t("form_fn")} <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" id="firstName" autoComplete="off" onChange={handleInputChange} required/>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="lastName" className="form-label">{t("form_ln")} <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" id="lastName" autoComplete="off" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="phone" className="form-label">{t("form_ph")} <span className="text-danger">*</span></label>
                        <img src={help} alt="tt_info" data-tooltip-id="tt-phone"/>
                        <input type="text" className="form-control" id="phone" autoComplete="off" onChange={handleInputChange} />
                        <ReactTooltip id="tt-phone" place="right">
                        Phone numbers can be up to 30 characters in length and should consist only of digits (0-9). Special characters such as '+', ',', '.', '(', ')', and '-' are allowed, but the '+' character can only appear at the beginning of the phone number. Please ensure that there are no spaces between the numbers.
                        </ReactTooltip>
                            </div>
                     <div className="col-md-6">
                        <label htmlFor="tenantName" className="form-label">{t("form_cmpny")} <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" id="tenantName" autoComplete="off" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="country" className="form-label">{t("form_cntry")} <span className="text-danger">*</span></label>
                        <select id="country" className="form-select" onChange={(e: any) => {setCountry(e.target.value)}}>
                            {countries && Object.keys(countries).map((obj:string)=>(
                               <option key={obj+" country"} value={obj}>{countries[obj]}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="city" className="form-label">{t("form_ct")} <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" id="city" autoComplete="off" onChange={handleInputChange}/>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="zipCode" className="form-label">{t("form_pcode")} <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" id="zipCode" autoComplete="off" onChange={handleInputChange}/>
                    </div>
                    <div className="col-md-12">
                        <label htmlFor="email" className="form-label">{t("form_mail")} <span className="text-danger">*</span></label>
                        <input type="email" className="form-control" id="email" autoComplete="off" onChange={handleInputChange}/>
                        <div>{t("form_mail_desc")}</div>
                    </div>
                    <div className="col-md-12">
                        <label htmlFor="password" className="form-label">{t("form_pass")} <span className="text-danger">*</span></label>
                        <input type="password" className="form-control" id="password" autoComplete="off" onChange={handleInputChange}/>
                        <div>{t("form_pass_desc")}</div>
                    </div>
                    <div className="col-md-12">
                        <label htmlFor="cpswrd" className="form-label">{t("form_c_pass")} <span className="text-danger">*</span></label>
                        <input type="password" className="form-control" autoComplete="off" id="cpswrd" value={cpswrd} onChange={(e)=>{setCpswrd(e.target.value)}}/>
                    </div>
                    <div className="col-md-12">
                        <label htmlFor="timeZone" className="form-label">{t("form_ttz")} <span className="text-danger">*</span></label>
                        <select id="timeZone" className="form-select" onChange={(e: any) => {SetTimeZone(e.target.value)}}>
                            {timeZones && Object.keys(timeZones).map((obj:any)=>(
                               <option key={obj+" time_zone"} value={obj}>{timeZones[obj]}</option>
                            ))}
                        </select>
                        <div>
                            {t("form_ttz_desc")}
                        </div>
                    </div>
                    <div className="col-md-12">
                        <label htmlFor="knowfrom" className="form-label">{t("form_how_hear")} {t(`${id}`)} <span className="text-danger">*</span></label>
                        <select id="knowfrom" className="form-select" onChange={(e:any)=>{setKnowFrom(e.target.value)}}>
                        {hear_options.map((opt: obj, i: number) => (<option value={opt.value} key={opt.value + i}>{opt.name}</option>))}
                        </select>
                    </div>
                    <div className="col-md-12 mt-25">
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="acknowledge" autoComplete="off" checked={acknowledge} onChange={()=>{setAcknowledge(!acknowledge)}}/>
                            <label className="form-check-label" htmlFor="acknowledge">
                                {t("form_ack")}
                            </label>
                        </div>
                    </div>
                    <div className="col-md-12 mt-25">
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="tandc" autoComplete="off" checked={tandc} onChange={()=>{setTandc(!tandc)}}/>
                            <label className="form-check-label" htmlFor="tandc">
                                {t("form_tac1")} <a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/learn/us/en/uscorp1/terms-conditions/art-software-license-agreements">{t("form_tac2")}</a> {t("form_tac3")}
                            </label>
                        </div>
                    </div>
                    <div className="col-md-12 row mt-25">
                        <div className="col-md-4">
                            <div className="captcha text-center br-5 mr-5 text-light prevent-select">{captchaText}</div>
                        </div>
                        <div className="col-md-1">
                            <a className="mt-5-custom" title="Click to change captcha" onClick={() => loadCaptcha()}><img src={refresh} alt="" /></a>
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="captchaText" className="form-label mt-15 text-center">{t("form_captcha")} <span className="text-danger">*</span> &rarr;</label>
                        </div>
                        <div className="col-md-4">
                            <input type="text" value={dCaptcha} autoComplete="off" onChange={(e: React.FormEvent<HTMLInputElement>) => setDCaptcha(e.currentTarget.value)} className="form-control mt-10" id="captchaText" />

                        </div>
                    </div>
                    <div className="col-12 text-center">
                        <a className={`btn text-white btn-secondary btn-lg ${acknowledge && tandc ? "":"disabled"}`} onClick={() => {registerUser()}}>{t("start_trial")} {loader ? <span className="loader"></span> : "" }</a>
                    </div>
                </form>
            </div>
            </div>
           )}
        </div>
    )
}

export default function StdInstall() {

    return (
        <div className="wrapper">
            <Header />
            <Content />
            <Footer />
        </div>
    );
}